import store from "../redux/store";
import { add, remove as removeToast } from "../redux/slices/toast.slice";

export const ToastFactory = () => {
  const showToast = (message, heading, options) => {
    store.dispatch(add({ message, heading, options }));
  };

  const remove = (id) => {
    store.dispatch(removeToast(id));
  };

  return { showToast, remove };
};
